module.exports = __webpack_public_path__ + "static/media/join-the-community.aea205a7.jpeg";